export default {
      id: "title-group-usage",
      viewBox: "0 0 89 14",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#title-group",
      toString: function () {
        return this.url;
      }
    }